import { useQuery } from "@apollo/client";
import { Link, useParams } from "react-router-dom";
import { GET_POSTS_BY_AUTHOR } from "../queries";
import { formatDate } from "../utils/format-date";

const PostsByAuthor = () => {
  const { authorSlug } = useParams<{ authorSlug: string }>(); // Get the authorSlug from the URL
  console.log("Author Slug: ", authorSlug);
  const perPage = 12;

  // Ensure the query runs only if authorSlug exists
  const { loading, error, data, fetchMore } = useQuery(GET_POSTS_BY_AUTHOR, {
    variables: {
      authorSlug: authorSlug!, // Non-null assertion since we expect it to be a string
      first: perPage,
      after: null, // always start with after = null for pagination
    },
    skip: !authorSlug, // Skip the query if authorSlug doesn't exist
  });

  const loadMorePosts = async () => {
    console.log("load more called");
    if (data?.posts.pageInfo.hasNextPage) {
      await fetchMore({
        variables: {
          authorSlug: authorSlug,
          first: perPage,
          after: data.posts.pageInfo.endCursor,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) return previousResult;

          return {
            posts: {
              ...fetchMoreResult.posts,
              nodes: [
                ...previousResult.posts.nodes,
                ...fetchMoreResult.posts.nodes,
              ],
            },
          };
        },
      });
    } else console.log("No more information");
  };

  if (loading) return <p>Loading posts by {authorSlug}...</p>;
  if (error) return <p>Error: {error.message}</p>;

  var posts = data?.posts?.nodes;

  return (
    <div className="mt-3 mx-3">
      {posts[0].author?.node && (
        <h2 className="text-center mb-8 text-3xl font-bold">
          Posts by {posts[0].author?.node.name}
        </h2>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((post: any) => (
          <Link
            to={`/post/${post.slug}`}
            className="no-underline text-inherit"
            key={post.id}
          >
            <div className="post-article p-4 border rounded-lg shadow-sm hover:shadow-md transition-shadow h-full">
              <div className="flex flex-col sm:flex-row gap-4">
                <div className="sm:w-5/12 flex-shrink-0">
                  <div className="image-wrapper">
                    <div className="skeleton-loader"></div>
                    {post.featuredImage?.node?.mediaDetails?.sizes && (
                      <img
                        src={
                          post.featuredImage.node.mediaDetails.sizes.find(
                            (s: any) => s.name === "thumbnail"
                          )?.sourceUrl
                        }
                        alt="Post"
                        className="real-img w-full h-auto object-cover rounded"
                        onLoad={(e) => {
                          const wrapper =
                            e.currentTarget.closest(".image-wrapper");
                          if (wrapper) {
                            const loader = wrapper.querySelector(
                              ".skeleton-loader"
                            ) as HTMLElement;
                            if (loader) loader.style.display = "none";
                            e.currentTarget.style.opacity = "1";
                          }
                        }}
                      />
                    )}
                  </div>
                </div>
                <div className="sm:w-7/12">
                  <h5
                    className="text-lg font-semibold mb-2"
                    dangerouslySetInnerHTML={{
                      __html: post.title,
                    }}
                  />
                  {post.author?.node?.name && (
                    <p className="text-sm mb-1">
                      <strong>Author:</strong> {post.author.node.name}
                    </p>
                  )}
                  {post?.date && (
                    <p className="text-sm">
                      <strong>Date: </strong>
                      {formatDate(post.date)}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div className="flex justify-center mt-12 mb-8">
        <button
          className="bg-[#0a5640] hover:bg-[#084533] text-white font-bold py-3 px-8 rounded-lg transition-colors"
          onClick={loadMorePosts}
        >
          Load More
        </button>
      </div>
    </div>
  );
};

export default PostsByAuthor;
